import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeVocabularies } from '../actions';
import VocabulariesActions from '../containers/VocabulariesActions';
import VocabulariesPanel from '../components/VocabulariesPanel';

export default {
  ...tabTemplate('vocabularies', VocabulariesPanel, matchSingleUrl(['vocabularies']), VocabulariesActions),
  ...tabCloser('closeVocabulariesTab', closeVocabularies),
  ...tabIcons('font'),
  access: ({ vocabularies }) => vocabularies.update,
  componentState: ({ url }) => categoryTab(url, 'admin'),
  order: 1100,
};
